<template>
<!--S 分页组件 -->
  <el-row class="page-wrap">
    <el-col class="col tr">
      <el-pagination layout="total, prev, pager, next" :total="totalPage" :page-size="30" @current-change="currentChange">
      </el-pagination>
    </el-col>
  </el-row><!--E 分页组件 -->
</template>

<script>
  export default {
    name: "adminDepartment",
    props: {
      totalPage: Number
    },
    data() {
      return {
        pageNum: []
      };
    },
    methods: {
      currentChange(data) {
        this.$emit("currentChange", data);
      }
    }
  };

</script>

<style lang="less" scoped="scoped">
  .page-wrap {
    padding: 15px 0 15px 20px;
    overflow: hidden;
    .col {
      box-sizing: border-box;
      padding-right: 20px;
      text-align: right;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/common/paginations.vue